import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "filter" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "filters" }
const _hoisted_4 = { class: "filterAndButtons" }
const _hoisted_5 = {
  key: 0,
  class: ""
}
const _hoisted_6 = { class: "center" }
const _hoisted_7 = {
  key: 1,
  class: ""
}
const _hoisted_8 = { class: "inputWrap noMarginLeft" }
const _hoisted_9 = {
  key: 2,
  class: ""
}
const _hoisted_10 = {
  key: 3,
  class: "inputWrap"
}
const _hoisted_11 = {
  key: 4,
  class: ""
}
const _hoisted_12 = {
  key: 5,
  class: "dateInputWrap"
}
const _hoisted_13 = {
  key: 6,
  class: "dateInputWrap"
}
const _hoisted_14 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_DropDownMultiple = _resolveComponent("DropDownMultiple")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_ButtonWhite = _resolveComponent("ButtonWhite")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hideHeader)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.$t('title.search')), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (this.comparisonListFacture !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_DropDown, {
                label: _ctx.$t('label.fournisseur.dropdown.montantttc'),
                list: _ctx.comparisonListFacture,
                selectedItem: _ctx.filter.comparisonFacture,
                display: _ctx.displayType,
                onSelect: _ctx.selectComparisonFacture,
                class: "width-250px"
              }, null, 8, ["label", "list", "selectedItem", "display", "onSelect"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('facture.montant.a')), 1),
        (this.comparisonListFacture !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_NumberInput, {
                  class: _normalizeClass(["filterInput", _ctx.filterMontant !== '' ? 'montant' : '']),
                  modelValue: _ctx.filterMontant,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterMontant) = $event)),
                  label: _ctx.$t('facture.filter.montantTTC')
                }, null, 8, ["modelValue", "label", "class"])
              ])
            ]))
          : _createCommentVNode("", true),
        (this.societeList !== undefined && _ctx.societeList !== [])
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_DropDownMultiple, {
                class: "selectSociete",
                label: _ctx.$t('label.bySociete'),
                list: _ctx.societeList,
                listTotal: _ctx.societeList,
                inputDisplay: this.filterSocieteDisplay,
                checkboxDisplay: this.societeCheckboxDisplay,
                selectedItems: _ctx.filter.societes,
                isChecked: this.isCheckedSociete,
                onAdd: _ctx.addSelectSociete,
                onRemove: _ctx.removeSelectSociete,
                onToggleSelectAll: _cache[1] || (_cache[1] = ($event: any) => (this.toggleSelectAll('societe'))),
                onMultipleSelectSearch: _ctx.multipleSelectSearchSociete,
                withSearch: true,
                "drop-down-bigger": true,
                search: _ctx.searchSociete
              }, null, 8, ["label", "list", "listTotal", "inputDisplay", "checkboxDisplay", "selectedItems", "isChecked", "onAdd", "onRemove", "onMultipleSelectSearch", "search"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.numeroFacture !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_TextInput, {
                class: "filterInput",
                modelValue: _ctx.filterNumero,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterNumero) = $event)),
                label: _ctx.$t('label.filtre.facture')
              }, null, 8, ["modelValue", "label"])
            ]))
          : _createCommentVNode("", true),
        (this.filter.statusList !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_DropDownMultiple, {
                label: _ctx.$t('label.byStatus'),
                list: _ctx.statusList,
                listTotal: _ctx.statusList,
                inputDisplay: this.filterStatusDisplay,
                checkboxDisplay: this.statusCheckboxDisplay,
                selectedItems: _ctx.filter.statusList,
                isChecked: this.isCheckedStatus,
                onAdd: _ctx.addSelectStatus,
                onRemove: _ctx.removeSelectStatus,
                onToggleSelectAll: _cache[3] || (_cache[3] = ($event: any) => (this.toggleSelectAll('status')))
              }, null, 8, ["label", "list", "listTotal", "inputDisplay", "checkboxDisplay", "selectedItems", "isChecked", "onAdd", "onRemove"]),
              _createVNode(_component_ReglePastille, { cle: "facturesFournisseur.statutRejeteeExclusif" }),
              _createVNode(_component_ReglePastille, { cle: "facturesFournisseur.filtreParDefaut" })
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.factureDateFrom !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_DatePicker, {
                dateValue: _ctx.filter.factureDateFrom,
                label: _ctx.$t('label.factureDateFrom'),
                onSetDate: this.setFilterFactureDateFrom,
                dateMax: _ctx.filter.factureDateTo
              }, null, 8, ["dateValue", "label", "onSetDate", "dateMax"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.factureDateTo !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_DatePicker, {
                dateValue: _ctx.filter.factureDateTo,
                label: _ctx.$t('label.factureDateTo'),
                onSetDate: this.setFilterFactureDateTo,
                dateMin: _ctx.filter.factureDateFrom
              }, null, 8, ["dateValue", "label", "onSetDate", "dateMin"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.hideButton)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.getClassByCritere())
          }, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_ButtonWhite, {
                onClick: _ctx.clearFilter,
                class: "clearBtn",
                text: _ctx.$t('button.clear')
              }, null, 8, ["onClick", "text"]),
              _createVNode(_component_ButtonBlue, {
                onClick: _ctx.search,
                class: "searchBtn",
                text: _ctx.$t('button.search')
              }, null, 8, ["onClick", "text"])
            ])
          ], 2))
        : _createCommentVNode("", true)
    ])
  ]))
}